// Types for src/data/catalog.json — the curated, pre-built sefer catalog.
//
// The catalog is a recursive tree of nodes. Every node either has a `ref`
// (it's a leaf checkbox row pointing at a Sefaria ref) or `children` (it's
// a group — category, sefer, siman, perek, etc.).
//
// The JSON is generated by scripts/build-catalog.mjs — run that script
// whenever you want to add or refresh sefarim.

export type CatalogNode = {
  english: string
  hebrew?: string
  /** Present only on leaf nodes. Sefaria-canonical ref (e.g. "Genesis 1"). */
  ref?: string
  /** Present only on group nodes. */
  children?: CatalogNode[]
}

/** The top-level catalog object. */
export type Catalog = {
  english: string
  children: CatalogNode[]
}

/** Build the URL to open a ref in Sefaria (bilingual view). */
export function sefariaUrl(ref: string): string {
  // Sefaria expects dot-joined refs in the URL path, e.g. "Genesis.1"
  // Spaces before section numbers are also accepted but dots are canonical.
  const encoded = encodeURIComponent(ref).replace(/%20/g, '_').replace(/%2C%20/g, '.')
  return `https://www.sefaria.org/${encoded}?lang=bi`
}

// Re-export the raw JSON with the correct type so consumers don't need
// to cast.  Vite resolves JSON imports at build time.
import rawCatalog from './catalog.json'
export const catalog = rawCatalog as Catalog
